export const CONTENT_LANGS = ['en', 'uk', 'ro'];

export const LANG_META = {
  en: { label: 'EN', html: 'en', og: 'en_US', date: 'en-US' },
  uk: { label: 'UA', html: 'uk', og: 'uk_UA', date: 'uk-UA' },
  ro: { label: 'RO', html: 'ro', og: 'ro_RO', date: 'ro-RO' },
};

const KNOWLEDGE_PREFIX = /^\/(foods|guides|meal-plans|recipes)(\/|$)/;

export function normalizeLang(lng) {
  const code = (lng || 'en').toLowerCase().split('-')[0];
  return CONTENT_LANGS.includes(code) ? code : 'en';
}

export function stripLangPrefix(pathname = '/') {
  const cleaned = pathname.replace(/^\/(uk|ro)(?=\/|$)/, '');
  return cleaned || '/';
}

export function langFromPath(pathname = '/') {
  if (pathname === '/uk' || pathname.startsWith('/uk/')) return 'uk';
  if (pathname === '/ro' || pathname.startsWith('/ro/')) return 'ro';
  return 'en';
}

export function isKnowledgePath(pathname = '/') {
  return KNOWLEDGE_PREFIX.test(stripLangPrefix(pathname));
}

export function localizedPath(path = '/', lang = 'en') {
  const bare = stripLangPrefix(path);
  const resolved = normalizeLang(lang);
  if (resolved === 'en' || !isKnowledgePath(bare)) return bare;
  return `/${resolved}${bare}`;
}

export function swapPathLang(pathname, nextLang) {
  return localizedPath(pathname, nextLang);
}
